import styled from 'styled-components';
import { CSSVars } from '@/styles/styles.config';

export const StyledHero = styled.section`
  background: url(/assets/hero-bg.webp);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center 0%;
  color: ${CSSVars.white};
  padding: 140px 20px 140px;
  text-align: center;
  position: relative;
  overflow: hidden;

  h1 {
    font-size: 1.875rem;
    font-weight: 300;
    margin-bottom: 20px;
    line-height: 1.15;
    position: relative;
    background: linear-gradient(277deg, #fff 48.61%, #808aad 109.97%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  p {
    font-size: ${CSSVars.fontSizeMD};
    color: rgba(255, 255, 255, 0.8);
    max-width: 620px;
    margin: 0 auto;
    line-height: 1.7;
    font-weight: 300;
    position: relative;
  }

  @media screen and (min-width: ${CSSVars.breakpointMD}) {
    padding: 160px 40px 160px;
    h1 { font-size: ${CSSVars.fontSize2XL}; }
    p { font-size: ${CSSVars.fontSizeLG}; }
  }

  @media screen and (min-width: ${CSSVars.breakpointLG}) {
    padding: 180px 40px 180px;
    h1 { font-size: ${CSSVars.fontSize3XL}; }
  }
`;

export const StyledStatBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px 28px;
  margin-top: 28px;
  position: relative;

  span {
    font-size: ${CSSVars.fontSizeSM};
    font-weight: 600;
    color: rgba(255, 255, 255, 0.9);
    white-space: nowrap;
  }
`;

export const StyledGrid = styled.section`
  background: ${CSSVars.white};
  border-top: 1px solid rgba(0, 0, 0, 0.07);
  padding: 60px 20px 80px;

  @media screen and (min-width: ${CSSVars.breakpointMD}) {
    padding: 80px 30px 100px;
  }

  @media screen and (min-width: ${CSSVars.breakpointLG}) {
    padding: 100px 40px 120px;
  }
`;

export const StyledGridInner = styled.div`
  max-width: 1000px;
  margin: 0 auto;
`;

export const StyledCardsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;

  @media screen and (min-width: ${CSSVars.breakpointMD}) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (min-width: ${CSSVars.breakpointLG}) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const StyledVerticalCard = styled.div`
  background: ${CSSVars.white};
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 18px;
  padding: 28px 24px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  transition: border-color 0.2s, box-shadow 0.2s, transform 0.2s;

  &:hover {
    border-color: rgba(76, 79, 255, 0.3);
    box-shadow: 0 6px 24px rgba(76, 79, 255, 0.1);
    transform: translateY(-2px);
  }

  .card-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: rgba(76, 79, 255, 0.08);
    color: ${CSSVars.blue500};
    margin: 0 auto 4px;
    svg { width: 24px; height: 24px; }
  }

  h2 {
    font-size: ${CSSVars.fontSizeMD};
    font-weight: 700;
    color: ${CSSVars.black};
    text-align: center;
    line-height: 1.3;
  }

  .subtypes {
    font-size: ${CSSVars.fontSizeXS};
    color: ${CSSVars.gray500};
    text-align: center;
    font-weight: 300;
  }

  .tagline {
    font-size: ${CSSVars.fontSizeSM};
    color: ${CSSVars.gray600};
    line-height: 1.65;
    font-weight: 300;
    text-align: center;
    flex: 1;
  }

  .card-meta {
    display: flex;
    justify-content: center;
    gap: 12px;
    margin-top: 4px;

    span {
      padding: 3px 10px;
      background: rgba(76, 79, 255, 0.06);
      border: 1px solid rgba(76, 79, 255, 0.15);
      border-radius: 6px;
      font-size: ${CSSVars.fontSizeXS};
      color: ${CSSVars.blue500};
      font-weight: 600;
    }
  }
`;

export const StyledCardCta = styled.a`
  display: inline-block;
  padding: 9px 18px;
  background: ${CSSVars.blue500};
  color: ${CSSVars.white};
  border: none;
  border-radius: 8px;
  font-size: ${CSSVars.fontSizeSM};
  font-weight: 700;
  text-decoration: none;
  text-align: center;
  transition: background 0.3s;
  margin-top: auto;

  &:hover {
    background: linear-gradient(270deg, ${CSSVars.pink300} 0%, ${CSSVars.blue500} 100%);
  }
`;

export const StyledBottomCta = styled.section`
  padding: 60px 20px 80px;
  background: ${CSSVars.gray50};
  text-align: center;

  h2 {
    font-size: 1.5rem;
    font-weight: 700;
    color: ${CSSVars.black};
    margin-bottom: 14px;
  }

  p {
    font-size: ${CSSVars.fontSizeMD};
    color: ${CSSVars.gray600};
    max-width: 600px;
    margin: 0 auto 28px;
    line-height: 1.7;
    font-weight: 300;
  }

  a {
    display: inline-block;
    padding: 12px 24px;
    background: ${CSSVars.blue500};
    color: ${CSSVars.white};
    border-radius: 8px;
    font-size: ${CSSVars.fontSizeSM};
    font-weight: 700;
    text-decoration: none;
    transition: background 0.3s;

    &:hover {
      background: linear-gradient(270deg, ${CSSVars.pink300} 0%, ${CSSVars.blue500} 100%);
    }
  }

  @media screen and (min-width: ${CSSVars.breakpointMD}) {
    padding: 80px 30px 100px;
    h2 { font-size: ${CSSVars.fontSize2XL}; }
  }
`;
